export interface BookedStay {
  city: string | null;
  start: string; // yyyy-mm-dd
  days: number;
}

function endOf(start: string, days: number): string {
  const d = new Date(`${start}T00:00:00Z`);
  d.setUTCDate(d.getUTCDate() + Math.max(days, 1) - 1);
  return d.toISOString().slice(0, 10);
}

/** The stays a newly blocked range lands on (blocking never cancels a trip, so the host is told). */
export function staysHitByBlock(blockStart: string, blockEnd: string, stays: BookedStay[]): BookedStay[] {
  return stays.filter((s) => s.start <= blockEnd && endOf(s.start, s.days) >= blockStart);
}
